import { Field, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'wouter'
import * as Yup from 'yup'
import { inputClass, labelClass, linkClass, submitButtonClass } from './authStyles'
import PasswordField from './PasswordField'

export default function LoginForm({ loginError, handleSubmit }) {
  const { t } = useTranslation()
  const [, setLocation] = useLocation()

  // Esquema de validación del formulario (POST o PUT):
  const validationSchema = Yup.object().shape({
    email: Yup.string().email(t('login.v_email_invalid')).required(t('login.v_email_required')),
    password: Yup.string().required(t('login.v_password_required'))
  })

  return (
    <>
      <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values)
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div>
              <label
                htmlFor="email"
                className={labelClass(touched.email && errors.email)}
              >
                {t('login.email')}
              </label>

              <Field
                id="email"
                name="email"
                type="email"
                className={`${inputClass(touched.email && errors.email)} mt-2`}
                autoComplete="username"
                placeholder="example@example.com"
              />

              <div
                className={`flex justify-start items-start w-full ${touched.email && errors.email ? 'visible' : 'invisible'}`}
              >
                <div className="flex w-full">
                  <p className="mt-1 text-sm leading-none text-red-600">
                    {errors.email || ' '}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-4">
              <div className="flex items-end justify-between mb-2">
                <label
                  htmlFor="password"
                  className={labelClass(touched.password && errors.password)}
                >
                  {t('login.password')}
                </label>

                <a
                  href="/forgot-password"
                  onClick={(e) => { e.preventDefault(); setLocation('/forgot-password') }}
                  className={linkClass}
                >
                  {t('login.forgot')}
                </a>
              </div>

              <PasswordField
                id="password"
                name="password"
                hasError={!!(touched.password && errors.password)}
                autoComplete="current-password"
              />

              <div
                className={`flex justify-start items-start w-full ${touched.password && errors.password ? 'visible' : 'invisible'}`}
              >
                <div className="flex w-full">
                  <p className="mt-1 text-sm leading-none text-red-600">
                    {errors.password || ' '}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-5">
              <button type="submit" className={`${submitButtonClass} capitalize`}>
                {t('login.submit')}
              </button>
            </div>

            <div
              className={`relative text-sm px-3 py-2 mt-3 text-red-700 bg-red-50 border border-red-200 rounded-lg ${loginError ? 'visible' : 'invisible'}`}
              role="alert"
            >
              <strong className="font-bold">{t('login.error_label')} </strong>
              <span className="block sm:inline">{loginError}</span>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

// Define los tipos de las props que recibe el componente actual
LoginForm.propTypes = {
  loginError: PropTypes.any,
  handleSubmit: PropTypes.func
}
